import React, { useEffect, useState } from 'react';

import { 
    Spinner, Sidebar, 
    ConfirmationModal, CustomPasswordInput, AlertMessage, SubmenuPopover 
} from "components";

import { func_url, func_validation, isArrayNotEmpty, isFunction, truncateValueAtPosMatch } from 'functions';

import logo from 'assets/images/xilnex_official_logo_grey.svg';
import homeIcon from 'assets/images/dashboard.svg';
import recusiveBillingIcon from 'assets/images/ic_recursive_billing_setup.svg';
import ic_suspend_outlet from 'assets/images/ic_suspend_outlet.svg';
import ic_com_reactivation from 'assets/images/ic_com_reactivation.svg';
import ic_activity_log from 'assets/images/ic_activity_log.svg';
import ic_invoice from 'assets/images/ic_invoice.svg';
import ic_manual_billing from 'assets/images/ic_manual_billing.svg';
import ic_debit_note from 'assets/images/ic_debit_note.svg';
import ic_advance_pay_setup from 'assets/images/ic_advance_pay_setup.svg';
import ic_alphypay_payment from 'assets/images/ic_alphypay_payment.svg';
import ic_account_control from 'assets/images/ic_account_control.svg';
import ic_transaction_history from 'assets/images/ic_transaction_history.svg';
import ic_performed_journal from 'assets/images/ic_performed_journal.svg';
import ic_outlet_status_change from 'assets/images/ic_outlet_status_change.svg';
import ic_reporting from 'assets/images/ic_reporting.svg';
import ic_legacy_tools from 'assets/images/ic_legacy_tools.svg';
import ic_company_info from 'assets/images/ic_company_info.svg';

import settingsIcon from 'assets/images/settings.svg';
import default_user from 'assets/images/default_user.png';
import ic_user_settings from 'assets/images/ic_user_settings.svg';

import { billingPortalBaseUrl } from "dataflow/billingPortal/constants";

import 'assets/scss/billingPortal/modules/dashboardSidebar.scss';
import { useDispatch } from 'react-redux';
import usePromiseInstance_authorization from 'dataflow/billingPortal/actions/config';
import { Toaster } from 'components/notification/Toaster';
import { useCustomSelector } from 'hooks';
import useResetPassword from './hooks/useResetPassword';
import { useAuthenticationActions } from 'dataflow/billingPortal/actions/useAuthentication.actions';
import { useHistory, useLocation } from 'react-router-dom';


export function DashboardSidebarPresentation({ userInfo }) {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const { logout } = useAuthenticationActions();
    const { logout_requesting } = useCustomSelector("authentication");
    const { userPermissions } = useCustomSelector("userManagementReducers");
    const request = usePromiseInstance_authorization();

    // States
    const {
        setIsModalVisible: setIsModalVisible_resetPwd,
        resetPwdModal
    } = useResetPassword(userInfo);

    let profileImage = func_validation.getObjectPropertyValue(userInfo, "profileImage", default_user);
    let fullName = func_validation.getObjectPropertyValue(userInfo, "FullName", "");
    if (func_validation.isStringEqual_caseInsensitive(fullName, "-")) fullName = "";
    let userEmail = func_validation.getObjectPropertyValue(userInfo, "UserName", "");
    if (func_validation.isStringEqual_caseInsensitive(userEmail, "-")) userEmail = "";

    const [totalCOMRequests, setTotalCOMRequests] = useState(0);
    const { isCOMRequestStatusUpdated } = useCustomSelector("companyInfo");
    function getCOMRequests() {
        request(null, (axios) => {
            if (isFunction(axios)) {
                axios.get('/ComInfo/GetRequest?requestStatus=Pending')
				.then(function (response) {
					// handle success
					let data = response?.data;
					if (isArrayNotEmpty(data)) {
						setTotalCOMRequests(data.length);
					}
					else setTotalCOMRequests(0);
				})
				.catch(function (response) {
					// handle error
					if (response?.data?.exceptionMessage) {
						Toaster({
							type: "error",
							msg: response?.data?.exceptionMessage
						})
					}
				})
				.finally(function () {
					// always executed
				});
            }
		});
    }
    useEffect(() => {
        getCOMRequests();
    }, [isCOMRequestStatusUpdated]);
    useEffect(() => {
        setInterval(() => {
            getCOMRequests();
        }, 300000)
    },[]);

    return (
        <>
            {/* Reset Password */}
            {resetPwdModal}

            <Sidebar sidebarClassName={"dashboardSidebar"}
                isWidthChangerIconVisible

                isHeaderVisible
                isHeaderImageVisible
                headerImageClassName={"dashboardSidebar-headerImage"}
                widthChangeIconClassName={"dashboardSidebar-headerImage-widthChangerIcon"}
                headerImage={logo} headerImageAlt={"Company Logo"}
                headerImageUrlRedirection={billingPortalBaseUrl + "dashboard"}

                isHeaderDetailsVisible
                isHeaderDetailsVisible_topBorder isHeaderDetailsVisible_bottomBorder
                headerDetailsDisplay={(isCollapsed) => {

                    return (
                        <div className={"dashboardSidebar-headerDetails d-flex align-items-center " +
                                        (isCollapsed? "justify-content-center ":"")}>

                            {/* Profile Image */}
                            {/* <img className={"dashboardSidebar-headerImage"}
                                src={profileImage}
                                alt={"Profile Image"}
                            /> */}

                            {/* User Details */}
                            {(!isCollapsed)? (
                                <div className={"dashboardSidebar-userDetailsWrapper"}>
                                    {/* Full Name */}
                                    <div className={"dashboardSidebar-fullName noWrap-text-ellipsis"}>
                                        {fullName}
                                    </div>

                                    {/* Profile Setting Icon */}
                                    <SubmenuPopover
                                        className={"dashboardSidebar-profileSettings"}
                                        
                                        triggerClassName={"dashboardSidebar-profileSettings-trigger"}
                                        trigger={(
                                            <div className={"d-flex justify-content-between"}>
                                                {/* Email */}
                                                <div className={"dashboardSidebar-userEmail noWrap-text-ellipsis"}>
                                                    {userEmail}
                                                </div>

                                                {/* Trigger */}
                                                <img
                                                    className={"dashboardSidebar-profileSettings-icon"}
                                                    src={ic_user_settings}
                                                    alt={"Profile Settings Icon"}
                                                />
                                            </div>
                                        )}
                                        triggerPosition={"right"}

                                        menu={[
                                            {
                                                label: "Reset Password",
                                                callbackFunc: () => setIsModalVisible_resetPwd(true)
                                            },
                                            {
                                                label: (
                                                    <>
                                                        <span>Logout</span>
                                                        {logout_requesting && <Spinner size={0} />}
                                                    </>
                                                ) ,
                                                callbackFunc: logout
                                            }
                                        ]}
                                    />
                                </div>
                            ):""}

                        </div>
                    );
                }}

                menuArray={[
                    {
                        itemIconDisplay: (<img className={"dashboardSidebar-menuItem-homeIcon"} src={homeIcon}/>),
                        itemLabel: "Home",
                        path: billingPortalBaseUrl + "dashboard",
                    },
                    {
                        itemIconDisplay: (<img src={recusiveBillingIcon}/>),
                        itemLabel: "Recursive Billing Setup",
                        isDisabled: !(userPermissions?.Internal_BillingSetup_View),
                        path: billingPortalBaseUrl + "dashboard/recursiveBillingSetup",
                    },
                    {
                        itemIconDisplay: (<img src={ic_advance_pay_setup}/>),
                        itemLabel: "Commitment Pay Setup",
                        isDisabled: !(userPermissions?.Internal_AdvancePay_View),
                        path: billingPortalBaseUrl + "dashboard/commitment-pay-setup",
                        subMenu: [
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Commitment Pay Setup",
                                isDisabled: !(userPermissions?.Internal_AdvancePay_View),
                                path: billingPortalBaseUrl + "dashboard/commitment-pay-setup",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Sync Down Debit Notes",
                                isDisabled: !(userPermissions?.Internal_Commitment_Add),
                                path: billingPortalBaseUrl + "dashboard/sync-down-debit-notes",
                            }
                        ]
                    },
                    {
                        itemIconDisplay: (<img src={ic_manual_billing}/>),
                        itemLabel: "Manual Billing",
                        path: billingPortalBaseUrl + "dashboard/manualBilling",
                    },
                    {
                        itemIconDisplay: (<img src={ic_invoice}/>),
                        itemLabel: "Invoices",
                        isDisabled: !(userPermissions?.Internal_ProformaInvoice_View),
                        path: billingPortalBaseUrl + "dashboard/invoices",
                        subMenu: [
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "General",
                                isDisabled: !(userPermissions?.Internal_ProformaInvoice_View),
                                path: billingPortalBaseUrl + "dashboard/invoices",
                            },
                            // {
                            //     isIconHidden: true,
                            //     isItemSelectedIndicatorHidden: true,
                            //     itemLabel: "Commitment Pay",
                            //     isDisabled: !(userPermissions?.Internal_ProformaInvoice_View),
                            //     path: billingPortalBaseUrl + "dashboard/invoices/commitmentPay",
                            // },
                        ]
                    },
                    {
                        itemIconDisplay: (<img src={ic_debit_note}/>),
                        itemLabel: "Debit Note",
                        path: billingPortalBaseUrl + "dashboard/debitNote",
                        isDisabled: !(userPermissions?.Internal_DebitNote_View),
                    },
                    {
                        itemIconDisplay: (<img src={settingsIcon}/>),
                        itemLabel: "User Management",
                        isDisabled: !(userPermissions?.Internal_User_View),
                        path: billingPortalBaseUrl + "dashboard/userManagement/user",
                        subMenu: [
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "User List",
                                isDisabled: !(userPermissions?.Internal_User_View),
                                path: billingPortalBaseUrl + "dashboard/userManagement/user",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "User Group",
                                isDisabled: !(userPermissions?.Internal_UserGroup_View),
                                path: billingPortalBaseUrl + "dashboard/userManagement/userGroup",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Permission",
                                isDisabled: !(userPermissions?.Internal_Permission_View),
                                path: billingPortalBaseUrl + "dashboard/userManagement/permission",
                            },
                        ]
                    },
                    {
                        itemIconDisplay: (<img src={ic_reporting}/>),
                        itemLabel: "Reporting",
                        isDisabled: !(userPermissions?.Internal_TrialComReport_View),
                        path: billingPortalBaseUrl + "dashboard/reporting/trialCOM",
                        subMenu: [
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Trial COM",
                                isDisabled: !(userPermissions?.Internal_TrialComReport_View),
                                path: billingPortalBaseUrl + "dashboard/reporting/trialCOM",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Mobile License Key",
                                isDisabled: !(userPermissions?.Internal_License_View),
                                path: billingPortalBaseUrl + "dashboard/reporting/mobileLicenseKeyControl",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "POS Count",
                                isDisabled: !(userPermissions?.Internal_PosCountReport_View),
                                path: billingPortalBaseUrl + "dashboard/reporting/posCount",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Billing Setup",
                                isDisabled: !(userPermissions?.Internal_UsageBillingReport_View),
                                path: billingPortalBaseUrl + "dashboard/reporting/billingSetup",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Product Summary",
                                isDisabled: !(userPermissions?.Internal_UsageBillingReport_View),
                                path: billingPortalBaseUrl + "dashboard/reporting/productSummary",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Revenue",
                                isDisabled: !(userPermissions?.Internal_RevenueReport_View),
                                path: billingPortalBaseUrl + "dashboard/reporting/revenue",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Sales Person Comm",
                                isDisabled: !(userPermissions?.Internal_SalesPersonReport_View),
                                path: billingPortalBaseUrl + "dashboard/reporting/salesPersonCommission/invoiceCommission",
                                subMenu: [
                                    {
                                        isIconHidden: true,
                                        isItemSelectedIndicatorHidden: true,
                                        itemLabel: "Invoice Comm",
                                        isDisabled: !(userPermissions?.Internal_SalesPersonReport_View),
                                        path: billingPortalBaseUrl + "dashboard/reporting/salesPersonCommission/invoiceCommission",
                                    },
                                    {
                                        isIconHidden: true,
                                        isItemSelectedIndicatorHidden: true,
                                        itemLabel: "Credit Note Comm",
                                        isDisabled: !(userPermissions?.Internal_SalesPersonReport_View),
                                        path: billingPortalBaseUrl + "dashboard/reporting/salesPersonCommission/creditNoteCommission",
                                    },
                                    {
                                        isIconHidden: true,
                                        isItemSelectedIndicatorHidden: true,
                                        itemLabel: "Quarterly Comm",
                                        isDisabled: !(userPermissions?.Internal_SalesPersonReport_View),
                                        path: billingPortalBaseUrl + "dashboard/reporting/salesPersonCommission/quarterlyCommission",
                                    },
                                    {
                                        isIconHidden: true,
                                        isItemSelectedIndicatorHidden: true,
                                        itemLabel: "Settings",
                                        isDisabled: !(userPermissions?.Internal_SalesPersonReport_View),
                                        path: billingPortalBaseUrl + "dashboard/reporting/salesPersonCommission/settings",
                                    },
                                ]
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Dealer Comm",
                                isDisabled: !(userPermissions?.Internal_DealerReport_View),
                                path: billingPortalBaseUrl + "dashboard/reporting/dealerCommission/invoiceCommission",
                                subMenu: [
                                    {
                                        isIconHidden: true,
                                        isItemSelectedIndicatorHidden: true,
                                        itemLabel: "Invoice Comm",
                                        isDisabled: !(userPermissions?.Internal_DealerReport_View),
                                        path: billingPortalBaseUrl + "dashboard/reporting/dealerCommission/invoiceCommission",
                                    },
                                    {
                                        isIconHidden: true,
                                        isItemSelectedIndicatorHidden: true,
                                        itemLabel: "Credit Note Comm",
                                        isDisabled: !(userPermissions?.Internal_DealerReport_View),
                                        path: billingPortalBaseUrl + "dashboard/reporting/dealerCommission/creditNoteCommission",
                                    },
                                    {
                                        isIconHidden: true,
                                        isItemSelectedIndicatorHidden: true,
                                        itemLabel: "Quarterly Comm",
                                        isDisabled: !(userPermissions?.Internal_DealerReport_View),
                                        path: billingPortalBaseUrl + "dashboard/reporting/dealerCommission/quarterlyCommission",
                                    },
                                    {
                                        isIconHidden: true,
                                        isItemSelectedIndicatorHidden: true,
                                        itemLabel: "Settings",
                                        isDisabled: !(userPermissions?.Internal_DealerReport_View),
                                        path: billingPortalBaseUrl + "dashboard/reporting/dealerCommission/settings",
                                    },
                                ]
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Store Report",
                                isDisabled: !(userPermissions?.Internal_StoreReport_View),
                                path: billingPortalBaseUrl + "dashboard/reporting/storeReport",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Activation Log",
                                isDisabled: !(userPermissions?.Internal_ActivationLog_View),
                                path: billingPortalBaseUrl + "dashboard/reporting/activationLog",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "API Usage",
                                isDisabled: !(userPermissions?.Internal_ApiUsage_View),
                                path: billingPortalBaseUrl + "dashboard/reporting/apiUsage",
                            },
                        ]
                    },
                    {
                        itemIconDisplay: (<img src={ic_com_reactivation}/>),
                        itemLabel: "COM Activation",
                        isDisabled: !(userPermissions?.Internal_ComInfo_View),
                        path: billingPortalBaseUrl + "dashboard/comActivation",
                        isNotificationVisible: (totalCOMRequests > 0),
                        notificationValue: (totalCOMRequests > 99)? "99+": totalCOMRequests
                    },
                    {
                        itemIconDisplay: (<img src={ic_activity_log}/>),
                        itemLabel: "Activity Log",
                        isDisabled: !(userPermissions?.Internal_General_ViewActivityLog),
                        path: billingPortalBaseUrl + "dashboard/activityLog",
                    },
                    // {
                    //     itemIconDisplay: (<img src={ic_alphypay_payment}/>),
                    //     itemLabel: "AlphyPay Payment",
                    //     isDisabled: !(userPermissions?.Internal_Payment_View),
                    //     path: billingPortalBaseUrl + "dashboard/alphyPayPayment",
                    // },
                    {
                        itemIconDisplay: (<img src={ic_legacy_tools}/>),
                        itemLabel: "COM Control Tools",
                        isDisabled: !(userPermissions?.Internal_AccControl_View),
                        path: billingPortalBaseUrl + "dashboard/comControlTools/comAccountControl",
                        subMenu: [
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "COM Account Control",
                                isDisabled: !(userPermissions?.Internal_AccControl_View),
                                path: billingPortalBaseUrl + "dashboard/comControlTools/comAccountControl",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Mobile License Key",
                                isDisabled: !(userPermissions?.Internal_MobileLicense_View),
                                path: billingPortalBaseUrl + "dashboard/comControlTools/mobileLicenseKeyControl",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Transaction History",
                                isDisabled: !(userPermissions?.Internal_TransactionHist_View),
                                path: billingPortalBaseUrl + "dashboard/comControlTools/transactionHistory",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Performed Journal",
                                isDisabled: !(userPermissions?.Internal_PerformedLog_View),
                                path: billingPortalBaseUrl + "dashboard/comControlTools/performedJournal",
                            },
                            {
                                isIconHidden: true,
                                isItemSelectedIndicatorHidden: true,
                                itemLabel: "Outlet Status Change",
                                isDisabled: !(userPermissions?.Internal_OutletStatus_View),
                                path: billingPortalBaseUrl + "dashboard/comControlTools/outletStatusChange",
                            },
                        ]
                    },
                    {
                        itemIconDisplay: (<img src={ic_company_info}/>),
                        itemLabel: "Company Info",
                        isDisabled: !(userPermissions?.Internal_ComInfoTools_View),
                        path: billingPortalBaseUrl + "dashboard/companyInfo",
                    },
                ]}

                isSubMenuIconHidden

                history={history}
                currentPath={location?.pathname}
            />
        </>
        
    );
}